export default __webpack_public_path__ + "static/media/dep3_3.5fff8c3d.jpg";